var _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBlanksheets = function SvgBlanksheets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "blanksheets_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blanksheets_svg__a)",
    d: "M0 0h40v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#blanksheets_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M0 0h40v40H0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "blanksheets_svg__a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#blanksheets_svg__c",
    transform: "scale(.0119)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "blanksheets_svg__c",
    width: 80,
    height: 80,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAYAAAAcaxDBAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMpSURBVHgB7dy/a1NRFAfwc25aKeKPUhBafxaXTgWpSxUHRSwUBR3yoOCis4M4uOc/0NVJoZvtYDsodNAOIg7SoXERhBZCjTgUqpRKzHvHE+IilNw2PbmPm3w/0Lwk3KR939z34553GyIAAAAAgPCYIvE5SY4MidwWosvEfJhCSdO6/r6KBvV6ZHx8hUulrFXzPorEYJreFece6d1zJDJAgbBzmX6IP1ORsWq5/ESf+tSqfTSBcjPMMQpMw3S6GNSbG7pcI0+gjmLBfJ7yxDyk4Q77msUTqEg/5atAzhV8jeIJNBII1BgCNYZAjSFQYwjUGAI1hkCNIVBjQcbyL5OkMEl0U4cZV/ThCWqHCMUgSKCTItd1U3iskYxrGew4dbEggWrPTHRxqXm3u4XZh4qMUg+E2RAkUGaOpu56UDjKG8ut5+gBavn0/Pw16oBvxeI7ff+rlAP0UGMI1BgCNYZAjSFQYwjUGAI15j0PlVLJVcvlCb17R5xrXOjf9xBSsmxUh0v/PaePLmwkyfPWL5RfBeaPNDCwMDw7u00R8AZaWV29WHDuoQYwpSs4RO2MyXnXOWmD+n73Wr1MT85rqciU7Owc1YfPKALeTV57yLSu2C1p1jGDFjj0YzikizEWeUCR8O9Dmc9oTzpGORLm4JPE2uUNVET6tVqU6zzSfz01CjjKG0OgxhCosZ6ppB+UHktEzzb++Nqhh+6RHhi3HHPF1w491C/V7rmpp49LUqu98TXunUCZ1/V2mfYry1Id1Hx3Iq9GFhdXfM17JlDdBa7rNaz71GHYhxpDoMYQqDEEagyBGkOgxhCosWjOQzeKxT1PYc5zrjN6qLGeCVSLG95KkYVeCTTV0tsaBdD1Y3kdw2/pJbGyZNk8BRBPoMwvqA26qf/QVN+f7Ot7SwFEE+ipubmOV4os4ChvDIEaQ6DGEKgxBGoMgRpDoMYQqDEEaswbKDtXp8bsiRxJoEqRBX+gIlVdoU3Kkf4NXykS/k1eZEELDEuNqk1jBhqF9Vt/vmigTykS3qnejS8krc7MTHC9Pp0RnaWQXyaQZdsF5z7E9G81AAAAAAB5+AsilsgT/7WOOwAAAABJRU5ErkJggg=="
  }))));
};

export default SvgBlanksheets;